const deliveryFee = (state = 0, action) => {
    switch(action.type) {
        case 'deliveryFee':
            return action.payload;
        default:
            return state;
    }
}

export default deliveryFee;